export type StoryAnimation = 'gradient-v1' | 'glass-v2' | 'glass-v3'

export type Story = Readonly<{
  title: string
  body: string
  gradientStart: string
  glassFirstColor?: string | null | undefined
  glassSecondColor?: string | null | undefined
  glassBackgroundColor?: string | null | undefined
  gradientEnd: string
  animationSpeed?: number | undefined
  animation: StoryAnimation
  textColor: string
  imagePath: string | null
  ctaLabel: string
  ctaPath: string
}>

/** A viewer item is independent of marketing or recommendation delivery. */
export type StorySequenceItem = Readonly<{ id: string; story: Story }>
export type StoryAdvanceReason = 'tap' | 'timer'

export type Visit = Readonly<{
  id: string
  timezone: string
  dayEndsAt: number
  recommendationRetryAfterSeconds?: number | null
}>

export type MarketingDecision = Readonly<{
  kind: 'marketing'
  reservationId: string
  campaignId: string
  revisionId: string
  expiresAt: number
  story: Story
}>
export type StoryDecision = MarketingDecision | { kind: 'none' }
export type StoryAction = 'cta' | 'close' | 'completed'
export type Receipt = Readonly<{
  reservationId: string
  shownAt: number
  firstAction: StoryAction | null
}>
export type PresenceCommand = Readonly<{
  clientId: string
  sequence: number
  state: 'visible' | 'hidden'
  timezone: string | null
}>
export type DecisionCommand = Readonly<{
  clientId: string
  visitId: string
  platform: 'web' | 'pwa'
  key: string
}>
export type ReceiptCommand = Readonly<{
  clientId: string
  reservationId: string
}>
export type Timed<T> = Readonly<{ value: T; serverTime: number | null }>

export class StoryFailure extends Error {
  constructor(
    readonly status: number | 'network' | 'contract',
    readonly code: string,
    readonly retryAfterMs = 0,
  ) {
    super(code)
    this.name = 'StoryFailure'
  }
}

export function isRetryable(error: unknown): boolean {
  return (
    error instanceof StoryFailure &&
    (error.status === 'network' ||
      error.status === 429 ||
      (typeof error.status === 'number' && error.status >= 500))
  )
}
